import React, { useContext } from "react"
import { GAME_DESCRIPTION } from "./CONTENT"
import { MyContext } from "../../context/createContext"

export default function GameDescription() {
  const { ctx } = useContext(MyContext)
  const {
    config: { rake },
  } = ctx
  return (
    <div>
      <h3>{GAME_DESCRIPTION.title}</h3>
      {GAME_DESCRIPTION.description.map((text, id) => (
        <p key={id}>{text}</p>
      ))}
      <p>The overall theoretical return to player (RTP) is {100 - rake}%</p>
    </div>
  )
}
